
// import { db } from '../firebase'; // Import your Firebase setup
// import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';
// import React, { useEffect, useState } from 'react';
// import './WarehouseManager.css'; // Import the CSS file for styling
// import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';

// // Function to fetch orders with 'NEW' status
// export const fetchNewOrders = async () => {
//   const ordersRef = collection(db, 'orders');
//   const q = query(ordersRef, where('status', '==', 'waiting for the warehouse'));
//   const snapshot = await getDocs(q);
//   return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
// };

// // Function to update an order's status and collection date in Firestore
// export const updateOrderStatusAndDate = async (orderId, status, collectionDate) => {
//   const orderDocRef = doc(db, 'orders', orderId);
//   await updateDoc(orderDocRef, { status, collectionDate });
// };

// // Function to update order items in Firestore
// export const updateOrderItems = async (orderId, updatedItems) => {
//   const orderDocRef = doc(db, 'orders', orderId);
//   await updateDoc(orderDocRef, { items: updatedItems });
// };

// // components/OrderManager.js


// const OrderManager = () => {
//   const user = useSelector((state) => state.auth.currentUser);
//   const [orders, setOrders] = useState([]);
//   const [editingOrderId, setEditingOrderId] = useState(null);
//   const [editingItems, setEditingItems] = useState([]);
//   const [selectedDate, setSelectedDate] = useState('');
//   const navigate = useNavigate();

//   useEffect(() => {

//     if (!user) {
//       navigate('/loginK');
//       setOrders([]); // Clear orders if no user
//       return;
//     }

//     // Fetch new orders from Firebase
//     const loadOrders = async () => {
//       const newOrders = await fetchNewOrders();
//       setOrders(newOrders);
//     };

//     loadOrders();
//   }, []);

//   const changeBodyBackground = (background) => {
//     document.body.style.background = background;
//   };


//   useEffect(() => {
//     changeBodyBackground('linear-gradient(to bottom, #9aa3e5, rgba(213, 213, 187, 0))');
//     return () => changeBodyBackground(''); // Reset background on unmount
//   }, []);

//   const handleEditOrder = (order) => {
//     setEditingOrderId(order.id);
//     setEditingItems(order.items);
//     setSelectedDate(order.collectionDate || ''); // Load existing collection date if available
//   };

//   const handleItemChange = (index, field, value) => {
//     const updatedItems = [...editingItems];
//     updatedItems[index][field] = value;
//     setEditingItems(updatedItems);
//   };

//   const handleUpdateOrder = async (orderId) => {
//     await updateOrderItems(orderId, editingItems);
//     setEditingOrderId(null);

//     // Update orders in state
//     setOrders((prevOrders) =>
//       prevOrders.map((order) =>
//         order.id === orderId ? { ...order, items: editingItems } : order
//       )
//     );
//   };

//   const handleConfirmOrder = async (orderId) => {
//     if (!selectedDate) {
//       alert('Please select a collection date to confirm the order.');
//       return;
//     }

//     await updateOrderStatusAndDate(orderId, 'approved', selectedDate);

//     // Remove confirmed order from the list
//     setOrders((prevOrders) => prevOrders.filter((order) => order.id !== orderId));
//   };

//   const formatDate = (timestamp) => {
//     if (timestamp && timestamp.seconds) {
//       const date = new Date(timestamp.seconds * 1000); // Convert seconds to milliseconds
//       return date.toLocaleDateString() + ' ' + date.toLocaleTimeString(); // Format as date and time
//     }
//     return '';
//   };

//   return (
//     <div className="order-manager-container">
//       <div className="header">
//         <h2>הזמנות לטיפולי: {orders.length}</h2>
//       </div>
//       {orders.map((order) => (
//         <div key={order.id} className="order-card">
//           <div className="order-header">
//             <h4>המזמין : {order.user || 'Unknown User'}</h4>
//             <span className="order-date">תאריך: {formatDate(order.orderDate)}</span>
//             <span className="order-flag">🚩</span>
//           </div>
//           {editingOrderId === order.id ? (
//             <>
//               {editingItems.map((item, index) => (
//                 <div key={index} className="order-item1">
//                   {item.name}
//                   <input
//                     type="number"
//                     value={item.quantity}
//                     onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
//                     className="item-quantity-input"
//                   />
//                 </div>
//               ))}
//               <div className="order-item1">
//                 <input
//                   type="date"
//                   id="collection-date"
//                   value={selectedDate}
//                   onChange={(e) => setSelectedDate(e.target.value)}
//                   className="date-input"
//                 />
//               </div>
//               <div className="button-group">
//                 <button onClick={() => handleUpdateOrder(order.id)} className="action-button save-button">שמירת שינוים</button>
//                 <button onClick={() => setEditingOrderId(null)} className="action-button cancel-button">דחית הזמנה</button>
//               </div>
//             </>
//           ) : (
//             <>
//               {order.items.map((item, index) => (
//                 <div key={index} className="">
//                   <span>{item.name} - כמ': {item.quantity}</span>
//                 </div>
//               ))}
//               <div className="button-group">
//                 <button onClick={() => handleEditOrder(order)} className="action-button edit-button">עריכה</button>
//                 <button onClick={() => handleConfirmOrder(order.id)} className="action-button confirm-button">אישור</button>
//               </div>
//             </>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default OrderManager;

import { db } from '../firebase'; // Import your Firebase setup
import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import './WarehouseManager.css'; // Import the CSS file for styling
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Function to fetch orders with 'waiting for the warehouse' status
export const fetchNewOrders = async () => {
  const ordersRef = collection(db, 'orders');
  const q = query(ordersRef, where('status', '==', 'waiting for the warehouse'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

// Function to update an order's status, collection date, and confirmation in Firestore
export const updateOrderStatusAndDate = async (orderId, status, collectionDate, confirmationNumber) => {
  const orderDocRef = doc(db, 'orders', orderId);
  await updateDoc(orderDocRef, { status, collectionDate, confirmationNumber });
};

// Function to update order items in Firestore
export const updateOrderItems = async (orderId, updatedItems) => {
  const orderDocRef = doc(db, 'orders', orderId);
  await updateDoc(orderDocRef, { items: updatedItems });
};

// Function to generate a random 8-digit number
const generateRandomNumber = () => {
  return Math.floor(10000000 + Math.random() * 90000000); // Generates a number between 10000000 and 99999999
};

// Function to check if the generated number is unique in the Firestore database
const isConfirmationNumberUnique = async (number) => {
  const ordersRef = collection(db, 'orders');
  const q = query(ordersRef, where('confirmationNumber', '==', number));
  const snapshot = await getDocs(q);
  return snapshot.empty; // Returns true if no document contains this number
};

const OrderManager = () => {
  const user = useSelector((state) => state.auth.currentUser);
  const [orders, setOrders] = useState([]);
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [editingItems, setEditingItems] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate('/loginK');
      setOrders([]); // Clear orders if no user
      return;
    }

    // Fetch new orders from Firebase
    const loadOrders = async () => {
      const newOrders = await fetchNewOrders();
      setOrders(newOrders);
    };

    loadOrders();
  }, [user, navigate]);

  const changeBodyBackground = (background) => {
    document.body.style.background = background;
  };

  useEffect(() => {
    changeBodyBackground('linear-gradient(to bottom, #9aa3e5, rgba(213, 213, 187, 0))');
    return () => changeBodyBackground(''); // Reset background on unmount
  }, []);

  const handleEditOrder = (order) => {
    setEditingOrderId(order.id);
    setEditingItems(order.items);
    setSelectedDate(order.collectionDate || ''); // Load existing collection date if available
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...editingItems];
    updatedItems[index][field] = value;
    setEditingItems(updatedItems);
  };

  const handleUpdateOrder = async (orderId) => {
    await updateOrderItems(orderId, editingItems);
    setEditingOrderId(null);

    // Update orders in state
    setOrders((prevOrders) =>
      prevOrders.map((order) =>
        order.id === orderId ? { ...order, items: editingItems } : order
      )
    );
  };

  const handleConfirmOrder = async (orderId) => {
    if (!selectedDate) {
      alert('אנא בחר תאריך איסוף כדי לאשר את ההזמנה.');
      return;
    }

    try {
      let unique = false;
      let confirmationNumber;

      // Generate a unique 8-digit confirmation number
      while (!unique) {
        confirmationNumber = generateRandomNumber();
        unique = await isConfirmationNumberUnique(confirmationNumber);
      }

      // Update the order with the confirmation number and status
      await updateOrderStatusAndDate(orderId, 'approved', selectedDate, confirmationNumber);

      // Remove confirmed order from the list
      setOrders((prevOrders) => prevOrders.filter((order) => order.id !== orderId));

      alert(`ההזמנה אושרה בהצלחה עם מספר אישור: ${confirmationNumber}`);
    } catch (error) {
      console.error('שגיאה באישור ההזמנה:', error); // Log error if there is an issue
      alert('לא הצליח לאשר את ההזמנה. אנא נסה שוב.');
    }
  };

  const formatDate = (timestamp) => {
    if (timestamp && timestamp.seconds) {
      const date = new Date(timestamp.seconds * 1000); // Convert seconds to milliseconds
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString(); // Format as date and time
    }
    return '';
  };

  return (
    <div className="order-manager-container">
      <div className="header">
        <h2>הזמנות לטיפולי: {orders.length}</h2>
      </div>
      {orders.map((order) => (
        <div key={order.id} className="order-card">
          <div className="order-header">
            <h4>המזמין : {order.user }</h4>
            <span className="order-date">תאריך: {formatDate(order.orderDate)}</span>
            <span className="order-flag">🚩</span>
          </div>
          {editingOrderId === order.id ? (
            <>
              {editingItems.map((item, index) => (
                <div key={index} className="order-item1">
                  {item.name}
                  <input
                    type="number"
                    value={item.quantity}
                    onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
                    className="item-quantity-input"
                  />
                </div>
              ))}
              <div className="order-item1">
                <input
                  type="date"
                  id="collection-date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  className="date-input"
                />
              </div>
              <div className="button-group">
                <button onClick={() => handleUpdateOrder(order.id)} className="action-button save-button">שמירת שינוים</button>
                <button onClick={() => setEditingOrderId(null)} className="action-button cancel-button">דחית הזמנה</button>
              </div>
            </>
          ) : (
            <>
              {order.items.map((item, index) => (
                <div key={index} className="">
                  <span>{item.name} - כמ': {item.quantity}</span>
                </div>
              ))}
              <div className="button-group">
                <button onClick={() => handleEditOrder(order)} className="action-button edit-button">עריכה</button>
                <button onClick={() => handleConfirmOrder(order.id)} className="action-button confirm-button">אישור</button>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default OrderManager;
